module.exports = __webpack_public_path__ + "static/media/randM.0b54c2ff.png";